export type CreateAssessmentResult = {
    isLegitimate: boolean,
    score: number,
};

export type ValidateResult = {
    success: boolean,
};

export type ConfirmResult = ConfirmValidResult|ConfirmInvalidResult;

type ConfirmValidResult = {
    isValid: true,
    errorMessage: null,
}

type ConfirmInvalidResult = {
    isValid: false,
    errorMessage: string,
}

export class Captcha {
    private static readonly endpoint: string = `${document.location.origin}/api/captcha`;

    public static async createAssessment(token: string, timeoutMs: number | null = null): Promise<CreateAssessmentResult> {
        const url = new URL("/api/captcha/create-assessment", document.location.origin);
        url.searchParams.set("token", token);

        let requestConfig: RequestInit | undefined;
        if (timeoutMs !== null) {
            const controller = new AbortController();
            setTimeout(() => controller.abort(), timeoutMs);
            requestConfig = {
                signal: controller.signal,
            };
        }

        try {
            const response = await fetch(url.toString(), requestConfig);

            if (!response.ok) {
                return {
                    isLegitimate: false,
                    score: 0,
                };
            }

            return response.json();
        } catch (e) {
            console.error(e);
            return {
                isLegitimate: false,
                score: 0,
            };
        }
    }

    public static async validate(captcha: string): Promise<ValidateResult> {
        const url = new URL("/api/captcha/validate", document.location.origin);
        url.searchParams.set("captcha", captcha);

        const response = await fetch(url.toString());

        if (!response.ok) {
            return {
                success: false,
            };
        }

        return  response.json();
    }

    public static async confirm(captcha: string, action: string): Promise<ConfirmResult | null> {
        const response = await fetch(`${this.endpoint}/confirm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8",
            },
            body: JSON.stringify({
                captcha,
                action,
            })
        });

        if (response.ok) {
            return response.json();
        }

        return null;
    }
}
